import { Capacitor } from '@capacitor/core';

/**
 * V601: Skip deprecated native system-bar manipulation on Android.
 *
 * Android 15 deprecated Window.setStatusBarColor / setNavigationBarColor /
 * getStatusBarColor. Version sniffing via navigator.userAgent is unreliable
 * because of Chromium UA reduction, OEM WebView rewrites, enterprise policy,
 * and custom WebView providers.
 *
 * Therefore, skip native StatusBar color/overlay manipulation on every Android
 * version. EdgeToEdge + CSS safe areas own Android layout.
 *
 * StatusBar.setStyle is intentionally NOT gated here because Capacitor v7 routes
 * it through WindowInsetsControllerCompat.
 */
export function shouldSkipNativeSystemBarManipulation(): boolean {
  return Capacitor.getPlatform() === 'android';
}
